<template lang="pug">
  .home
    SvgSpriteSheet
    SvgKitchen(:width="width" :height="height")
</template>

<script>
import SvgKitchen from '@/components/graphics/SvgKitchen.vue';
import SvgSpriteSheet from '@/components/graphics/SvgSpriteSheet.vue';

export default {
  name: 'home',
  components: {
    SvgKitchen,
    SvgSpriteSheet,
  },

  data() {
    return {
      width: 100,
      height: 100,
    };
  },

  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.width = this.$el.clientWidth;
      this.height = this.$el.clientHeight;
    },
  },

};
</script>

<style lang="scss" scoped>
.home {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>
